import SDIcon from './SDIcon'

const IconCarbonCloudLogging = (props) => (
  <SDIcon title='CloudLogging' {...props}>
    <path
    d='M28,16v6H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z'
    transform='translate(0 0)'
    />
    <rect x='18' y='4' width='12' height='2' />
    <rect x='18' y='8' width='12' height='2' />
    <rect x='18' y='12' width='6' height='2' />
  </SDIcon>
)

export default IconCarbonCloudLogging
